const TARGET_TICK_COUNT = 8;
const DENSE_TARGET_TICK_COUNT = 14;
const MAX_ALL_LABEL_POINTS = 14;

const buildTickIndexes = (totalPoints: number, targetTickCount: number): Set<number> => {
  const tickIndexes = new Set<number>();
  if (totalPoints <= 0 || targetTickCount <= 1) return tickIndexes;

  const step = Math.max(1, Math.ceil((totalPoints - 1) / (targetTickCount - 1)));
  for (let position = 0; position < totalPoints; position += step) {
    tickIndexes.add(position);
  }
  tickIndexes.add(totalPoints - 1);

  return tickIndexes;
};

export const buildTickLabelInterval = (
  totalPoints: number,
): ((value: string, index: number) => boolean) | 'auto' => {
  if (totalPoints <= TARGET_TICK_COUNT) return 'auto';
  const tickIndexes = buildTickIndexes(totalPoints, TARGET_TICK_COUNT);

  return (_value: string, index: number) => tickIndexes.has(index);
};

export const buildAdaptiveTickLabelInterval = (
  totalPoints: number,
  preferAllLabels: boolean,
): ((value: string, index: number) => boolean) | 'auto' => {
  if (!preferAllLabels) return buildTickLabelInterval(totalPoints);
  if (totalPoints <= MAX_ALL_LABEL_POINTS) return showEveryTickLabel;
  const tickIndexes = buildTickIndexes(totalPoints, DENSE_TARGET_TICK_COUNT);

  return (_value: string, index: number) => tickIndexes.has(index);
};

export const showEveryTickLabel = (): boolean => true;
